module.exports = __webpack_public_path__ + "static/img/kucun.9a76281c.png";